import { action, computed, observable, set, makeObservable } from 'mobx';
import { constructNewFetch, IFetch } from '../classes/Fetch';

export default class FetchingService {
  private fetch: IFetch = observable.object(constructNewFetch());

  public setFetchDefault = () => {
    set(this.fetch, constructNewFetch());
  };

  public fetching = () => {
    set(this.fetch, constructNewFetch({ fetching: true }));
  };

  public fetchedSuccess = () => {
    set(
      this.fetch,
      constructNewFetch({
        fetched: true,
        success: true,
      })
    );
  };

  public fetchedError = (error?: string | null) => {
    set(
      this.fetch,
      constructNewFetch({
        errorMessage: error || null,
        fetched: true,
        success: false,
      })
    );
  };

  constructor() {
    makeObservable(this, {
      setFetchDefault: action,
      fetching: action,
      fetchedSuccess: action,
      fetchedError: action,
      getFetching: computed,
      getFetch: computed,
    });
  }

  public get getFetching(): boolean {
    return this.fetch.fetching!;
  }

  public get getFetch(): IFetch {
    return this.fetch;
  }
}
